import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    isAuthenticated: false
  }),
  getters: {
    getUserId: (state) => state.user?.id,
    getUser: (state) => state.user,
    getRole: (state) => state.user?.role,
    isAdmin: (state) => state.user?.role === 'admin' || state.user?.role === 'superadmin',
    isManager: (state) => state.user?.role === 'manager',
    isStaff: (state) => state.user?.role === 'staff',
    isSuperAdmin: (state) => state.user?.role === 'superadmin',
    isLoggedIn: (state) => state.isAuthenticated && state.user !== null
  },
  actions: {
    setUser(user) {
      this.user = user
      this.isAuthenticated = true
    },
    clearUser() {
      this.user = null
      this.isAuthenticated = false
    },
    initFromLocalStorage() {
      // Versuche den Token zu finden
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }
      
      try {
        // Benutzer aus localStorage laden
        const userJson = localStorage.getItem('user')
        if (userJson) {
          this.user = JSON.parse(userJson)
          this.isAuthenticated = true
        }
        return true
      } catch (error) {
        console.error('Fehler beim Laden des Benutzers:', error)
        return false
      }
    }
  }
}) 